import { FaXmark } from "react-icons/fa6";
import * as C from "./styles.js";
import { useEffect, useState } from "react";
import { FaSortDown, FaSortUp } from "react-icons/fa";

export default function Filters({ showFilters, setShowFilters, filters, setFilters }) {

    const [minYear, setMinYear] = useState("2000");
    const [maxYear, setMaxYear] = useState("");
    const [yearOrder, setYearOrder] = useState("asc");
    const [ratingOrder, setRatingOrder] = useState("asc");
    const [sortBy, setSortBy] = useState("release_date");

    const handleApplyFilters = () => {
        setFilters({ minYear, maxYear, yearOrder, ratingOrder, sortBy });
        setShowFilters(false);
    };

    useEffect(()=>{

        const currentYear = new Date().getFullYear();
        setMaxYear(currentYear)
        const years = Array.from({ length: currentYear - 1949 }, (_, i) => 1950 + i);

    }, []);

    
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1949 }, (_, i) => 1950 + i);

    return (
        <C.Container showFilters={showFilters}>
            <C.Content showFilters={showFilters}>
                <header className="header-filters">
                    <h3>Filtros</h3>
                    <button onClick={() => setShowFilters(false)}>
                        <FaXmark size={20} color="#fff" />
                    </button>
                </header>

                <div className="filter-group">
                    <label>Ano de Lançamento:</label>
                    <div className="filter-row">
                        <select
                            value={minYear}
                            onChange={(e) => setMinYear(e.target.value)}
                        >
                            <option value="">Mínimo</option>
                            {Array.from(
                                { length: new Date().getFullYear() - 1900 + 1 },
                                (_, index) => (
                                    <option key={1900 + index} value={1900 + index}>
                                        {1900 + index}
                                    </option>
                                )
                            )}
                        </select>
                        <span>Até</span>
                        <select
                            value={maxYear}
                            onChange={(e) => setMaxYear(e.target.value)}
                        >
                            <option value="">Máximo</option>
                            {Array.from(
                                { length: new Date().getFullYear() - 1900 + 1 },
                                (_, index) => (
                                    <option key={1900 + index} value={1900 + index}>
                                        {1900 + index}
                                    </option>
                                )
                            )}
                        </select>
                    </div>
                </div>

                <div className="filter-group">
                    <label>Ordenar por:</label>
                    <div className="order-by">
                        <select
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value)}
                        >
                            <option value="release_date">Data de Lançamento</option>
                            <option value="vote_average">Avaliações</option>
                        </select>
                        <button
                            onClick={() =>
                                sortBy === "release_date"
                                    ? setYearOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                                    : setRatingOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                            }
                            className="order-button"
                        >
                            {sortBy === "release_date" ? (
                                yearOrder === "asc" ? (
                                    <span><i class="fa-solid fa-arrow-down-short-wide"></i></span>
                                ) : (
                                    <span><i class="fa-solid fa-arrow-down-wide-short"></i></span>
                                )
                            ) : ratingOrder === "asc" ? (
                                <span><i class="fa-solid fa-arrow-down-short-wide"></i></span>
                            ) : (
                                <span><i class="fa-solid fa-arrow-down-wide-short"></i></span>
                            )}
                        </button>
                    </div>
                    <span className="span-order">
                    {sortBy === "release_date"
                        ? yearOrder === "asc"
                        ? "(Crescente)"
                        : "(Decrescente)"
                        : ratingOrder === "asc"
                        ? "(Crescente)"
                        : "(Decrescente)"
                    }
                    </span>
                </div>

                <div className="div-bts-apply-changes">
                    {Object.keys(filters).length > 0 && 
                        <button onClick={()=>setFilters({})} className="bt-remove-filters">
                            <i class="fa-solid fa-xmark"></i> Remover Filtros
                        </button>
                    }
                    <button onClick={handleApplyFilters} className="apply-button">
                        <i class="fa-solid fa-check"></i> Aplicar Filtros
                    </button>
                </div>
            </C.Content>
        </C.Container>
    );
}
